import { render, staticRenderFns } from "./ContactPersonCreation.vue?vue&type=template&id=1065e8f4"
import script from "./ContactPersonCreation.vue?vue&type=script&lang=js"
export * from "./ContactPersonCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports